
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M36.114 15.283c0 7.735-10.493 17.561-10.493 17.561s-10.493-9.826-10.493-17.561c0-2.637 1.105-5.167 3.073-7.032s4.637-2.913 7.42-2.913 5.452 1.048 7.42 2.913 3.073 4.395 3.073 7.032"}}),_c('path',{attrs:{"fill":"#fff","d":"M25.62 18.756c1.932 0 3.498-1.555 3.498-3.473s-1.566-3.473-3.497-3.473c-1.932 0-3.498 1.555-3.498 3.473s1.566 3.473 3.498 3.473"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M11.886 40.504a3.362 3.362 0 1 1 6.724 0v.203a3.362 3.362 0 1 1-6.724 0zM30.835 40.504a3.362 3.362 0 1 1 6.724 0v.203a3.362 3.362 0 0 1-6.724 0zM21.463 40.504a3.362 3.362 0 1 1 6.723 0v.203a3.362 3.362 0 1 1-6.724 0z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M34.28 13.876c0 7.734-10.493 17.56-10.493 17.56s-10.493-9.826-10.493-17.56c0-2.638 1.105-5.167 3.073-7.032s4.637-2.913 7.42-2.913 5.452 1.048 7.42 2.913 3.073 4.394 3.073 7.032Z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M23.787 17.348c1.931 0 3.498-1.555 3.498-3.472s-1.567-3.473-3.498-3.473-3.498 1.554-3.498 3.473c0 1.917 1.566 3.472 3.498 3.472ZM10.441 39.281a3.362 3.362 0 1 1 6.724 0 3.362 3.362 0 0 1-6.724 0ZM29.39 39.281a3.362 3.362 0 1 1 6.723 0 3.362 3.362 0 0 1-6.723 0ZM20.018 39.281a3.362 3.362 0 1 1 6.723 0 3.362 3.362 0 0 1-6.724 0Z"}})])
          )
        }
      }
    